export interface KrakenBaseEvent<T> {
    version: number;
    eventDate: string;
    eventId: string;
    context: {
        senderId: string;
    };
    type: string;
    properties: T;
}

export interface KrakenSuggestionEvent {
    searchTerm: string;
}

export interface KrakenRecommendationViewedEvent {
    fragmentName: string;
    products: KrakenRecommendationViewedProduct[];
}

export interface KrakenRecommendationViewedProduct {
    articleName: string;
    masterArticleNo: number;
    salesArticleNo: string;
    position: number;
}

export enum SearchFragmentName {
    SearchBoxHeaderTop = "SearchBoxHeaderTop",
    SearchBoxHeaderFlyout = "SearchBoxHeaderFlyout",
    SearchBoxSearchResultPage = "SearchBoxSearchResultPage",
    SearchBoxMegaMenu = "SearchBoxMegaMenu",
    SearchBox = "SearchBox"
}
